/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'arrow-reduir': {
    width: 444,
    height: 53,
    viewBox: '0 0 444 53',
    data: '<path pid="0" d="M0 5a5 5 0 0 1 5-5h434a5 5 0 0 1 5 5v48H0V5z" _fill="#D90E15"/>'
  }
})
